export default __webpack_public_path__ + "static/media/Chubs.344fdad7.ttf";